import { supabase } from '../../lib/supabaseClient';
import type { Database } from '../../types/database.types';

export type GmailInboxQueuedItem = Database['public']['Views']['v_gmail_inbox_to_triage']['Row'];
export type GmailInboxIgnoredItem = Database['public']['Views']['v_gmail_inbox_ignored_recent']['Row'];
export type DossierEmail = Database['public']['Tables']['gmail_archived_emails']['Row'];

export async function listGmailQueued(): Promise<GmailInboxQueuedItem[]> {
  const { data, error } = await supabase
    .from('v_gmail_inbox_to_triage')
    .select('*')
    .order('internal_date', { ascending: false });
  if (error) throw error;
  return data ?? [];
}

export async function listGmailIgnoredRecent(): Promise<GmailInboxIgnoredItem[]> {
  const { data, error } = await supabase
    .from('v_gmail_inbox_ignored_recent')
    .select('*')
    .order('internal_date', { ascending: false });
  if (error) throw error;
  return data ?? [];
}

export async function dismissGmailMessage(
  processedMessageId: string,
  reason: string = 'manual_dismiss',
): Promise<void> {
  const { error } = await supabase.rpc('gmail_dismiss_message', {
    p_processed_message_id: processedMessageId,
    p_reason: reason,
  });
  if (error) throw error;
}

export async function assignGmailMessageToDossier(
  processedMessageId: string,
  dossierId: string,
): Promise<void> {
  const { error } = await supabase.functions.invoke('gmail-assign-message', {
    body: { processed_message_id: processedMessageId, dossier_id: dossierId },
  });
  if (error) throw error;
}

export async function countGmailQueued(): Promise<number> {
  const { count, error } = await supabase
    .from('v_gmail_inbox_to_triage')
    .select('id', { count: 'exact', head: true });
  if (error) throw error;
  return count ?? 0;
}

export async function listDossierEmails(dossierId: string): Promise<DossierEmail[]> {
  const { data, error } = await supabase
    .from('gmail_archived_emails')
    .select('*')
    .eq('dossier_id', dossierId)
    .order('sent_at', { ascending: false });
  if (error) throw error;
  return data ?? [];
}
